<template>
    <section class="">
      <v-card flat class="pa-0 ma-0">
        <v-card-text>
            <v-row class="ms-1 me-1 my-0">
                <v-col cols="12" sm="3" md="3">
                  <v-switch
                    :label="` Cover Fund Limit(Payout Agent)`"
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-switch
                    :label="` User Cash Mgmt Enable`"
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-switch
                    :label="`Calculate Payout Commision Daily`"
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-switch
                    :label="`Credit limit disable`"
                  ></v-switch>
                </v-col>
              </v-row>
          <v-row class="ms-1 me-1 my-0">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0 required">
                Date of Agreement
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="Date of Agreement"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0 required">
                Partner Settlement In
              </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder=" Partner Settlement In"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Settlement Date
              </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder="Settlement Date"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Tax Type
              </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder="Tax Type"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1 my-0">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Credit Limitation to CDN TRN
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
               Limit Per Transaction Send
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Max Payout Amt Per TXN(Cash Pay)
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Max Payout Amt Per TXN( AC deposit)
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1 my-0">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0 required">
                Date Format
              </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Default HD Margin
              </label>
              <div class="d-flex">
                <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-autocomplete>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder=""
              ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <span v-if="this.getCompanyDetails && this.getCompanyDetails.created_by">
          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Created By :{{
                this.getCompanyDetails && this.getCompanyDetails.created_by
                  ? this.getCompanyDetails.created_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Created Date :{{
                this.getCompanyDetails && this.getCompanyDetails.created_date
                  ? this.getCompanyDetails.created_date
                  : null
              }}</v-col
            >
          </v-row>
          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Updated By :{{
                this.getCompanyDetails && this.getCompanyDetails.modified_by
                  ? this.getCompanyDetails.modified_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Updated Date :{{
                this.getCompanyDetails && this.getCompanyDetails.modified_date
                  ? this.getCompanyDetails.modified_date
                  : null
              }}</v-col
            >
          </v-row>
  
          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Approved By :{{
                this.getCompanyDetails && this.getCompanyDetails.approved_by
                  ? this.getCompanyDetails.approved_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Approved Date :{{
                this.getCompanyDetails && this.getCompanyDetails.approved_date
                  ? this.getCompanyDetails.approved_date
                  : null
              }}</v-col
            >
          </v-row>
        </span>
        <v-divider class="mb-0 pa-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" small @click="submitPartnerOtherInfo">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </section>
  </template>
  
  <script>
  import alerts from "@/mixins/alerts";
//   import partnerService from "@/services/partnerService/partnerService.js";
import { FieldRequired } from "@/utils/validation.js"; 
  export default {
    mixins: [alerts],
    data() {
      return {
        FieldRequired,
        SettleData:[],
        settle_Details:{

        },
      };
    },
    props: {
      getCompanyDetails: {
        type: Object,
      },
    },
    mounted() {
      if (this.getCompanyDetails.partner_id) {
        this.getPartnerInfo();
      }
    },
    methods: {
      async submitPartnerOtherInfo() {
        // const routerDataItem = this.$route.query.partner_id;
      },
      async getPartnerInfo() {
        // const routerDataItem = this.$route.query.partner_id;
        // if (routerDataItem) {
        //   try {
        //     const responseData = await partnerService.getPartnerOtherInfo(
        //       routerDataItem
        //     );
        //     if (responseData.status === 200) {
        //       this.otherDetails = responseData.data.data[0];
        //       console.log(this.otherDetails, "partner info data");
        //     } else {
        //       this.showAlertError("Failed:" + responseData.data.message);
        //     }
        //   } catch (e) {
        //     console.log(e);
        //   }
        // }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "@/global.scss";
  .required:after {
    content: " *";
    color: red;
  }
  </style>
  